export default __webpack_public_path__ + "static/media/vid.e8c6c8d7.mp4";